
'use strict'

import Validate from './Validate';

class Length extends Validate {
    
    constructor(min = 0, max = 255){
        super();
        this.error = '{name} entre ' + min + ' y ' + max + ' caracteres';
        this.min = min;
        this.max = max;
    }

    validate (value) {
        return value.length < this.min || value.length > this.max ? false : true;
    }
}

export default Length;
